import Commands from "./commands/commands.js";
export const commands = {
    commands: Commands
};
